// extracted by mini-css-extract-plugin
export default {"button":"styles_button__JkeST","orderHeaderDoubleArrow":"styles_orderHeaderDoubleArrow__pbvuK","redButton":"styles_redButton__fZyyA","greenButton":"styles_greenButton__uuTro"};